import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractDialogComponent } from '../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../Core/Dialogs/services/dialog.service';
import { FullProfileAnimationModel } from '../../../Core/Dialogs/models/full-profile-animation.model';
import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';

import { ViDimensionEnum }  from '../../enums/vi-dimension.enum';
import { ViIntentEnum }  from '../../enums/vi-intent.enum';
import { ViQuestionApi } from '../../../api/visibilityIntelligence/models/vi-question.api.model';


@Component({
    selector: 'agpr-vi-manually-add-question-panel',
    templateUrl: './vi-manually-add-question-panel.component.html',
    styleUrls: ['./vi-manually-add-question-panel.component.scss'],
    standalone: false
})
export class ViManuallyAddQuestionPanelComponent extends AbstractDialogComponent {
    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;

    readonly id = 'viManuallyAddQuestionPanel';
    readonly buttonTypes = ButtonTypesEnum;

    hideSlideOverlay: boolean = false;
    confirmed: boolean = false;
    addAnotherQuestion: boolean = false;

    question: ViQuestionApi = this.createQuestion();
    addedQuestions: ViQuestionApi[] = [];

    hasError: boolean = true;

    constructor(
        public coreDialogService: CoreDialogService
    ) {
        super(coreDialogService, 'ViManuallyAddQuestionPanel');
    }

    updateHasError(): void {
        this.hasError = !this.question.question?.trim() || !this.question.expectedAnswerSignals?.length;
    }

    addQuestion(): void {
        if (this.hasError) {
            return;
        }

        this.addedQuestions.push(this.question);
        this.confirmed = true;

        if (this.addAnotherQuestion) {
            this.question = this.createQuestion();
            this.hasError = true;
            return;
        }

        this.hideSlideOverlay = true;
    }

    cancel(): void {
        this.hideSlideOverlay = true;
    }

    close(overlayVisibility: boolean): void {
        if (!overlayVisibility) {
            this.closeDialog(this.confirmed ? this.addedQuestions : null);
        }
    }

    private createQuestion(): ViQuestionApi {
        return {
            id: '',
            question: '',
            dimension: ViDimensionEnum.brandIdentity,
            metrics: [],
            isBranded: true,
            intentType: ViIntentEnum.informational,
            expectedAnswerSignals: [],
            rationale: ''
        };
    }
}
